import { rem } from 'polished';
import styled, { css } from 'styled-components';

import Subtitle from '../Subtitle';
import { IStyledLinkProps } from './SimplePagination.types';

const Typography = css`
  font-size: ${rem('16px')};
  font-weight: 700;
`;

export const StyledArrow = styled.span`
  display: inline-flex;

  & svg {
    width: ${rem('12px')};
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSubtitle = styled(Subtitle)`
  margin: 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  ${Typography}
`;

export const StyledLink = styled.span<IStyledLinkProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ disabled, theme, user }) =>
    user && !disabled ? theme.colors[user].main : theme.colors.cross.silverFox};
  text-decoration: underline;
  ${Typography}

  &:first-child {
    ${StyledArrow} {
      margin-right: ${rem('10px')};

      svg {
        transform: rotate(90deg);
      }
    }
  }

  &:last-child {
    ${StyledArrow} {
      margin-left: ${rem('10px')};

      svg {
        transform: rotate(-90deg);
      }
    }
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }
`;
